import { Button } from './ui/Button';
import { cn } from 'utils/classnames';
import { DISPOSITION_COLORS } from 'utils/constants';

interface MoveToPRScreenProps {
  responseState: string;
  responseMsg?: string;
  trackingId: string;
  title?: string;
  children?: React.ReactNode;
  handleCancel: () => void;
}

const isExceptionState = (s: string) => s.toLowerCase().includes('exception');

export const MoveToPRScreen = ({
  responseState,
  responseMsg,
  trackingId,
  children,
  handleCancel,
}: MoveToPRScreenProps) => {
  const isException = isExceptionState(responseState);
  const colors = isException ? DISPOSITION_COLORS.EXCEPTION : DISPOSITION_COLORS.PROBLEM;
  const stateLabel = isException ? 'EXCEPTION' : 'PROBLEM';
  const icon = isException ? '🔶' : '⚠️';
  const cancelTextColor = isException ? 'text-amber-700' : 'text-red-700';
  const ringOffsetColor = isException ? 'ring-offset-amber-600' : 'ring-offset-red-700';

  return (
    <div className={cn('-mx-4 -mb-6 flex min-h-full flex-col items-center px-6 pb-6 pt-6', colors.gradient)}>
      <div className="mb-4 text-center">
        <p className="text-6xl font-black uppercase tracking-widest text-white leading-none">
          {stateLabel}
        </p>
        <p className="mt-1 text-sm font-bold uppercase tracking-wide text-white/70">
          Move to Problems Team
        </p>
      </div>

      <h1 className="mb-5 text-base font-bold text-white">Tracking# {trackingId}</h1>

      <div className="w-full flex flex-col items-center gap-3 mb-8">
        <Button
          type="button"
          className={`h-14 w-full rounded-2xl bg-white text-lg font-bold shadow-lg hover:bg-white/90 ${cancelTextColor}`}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        {children}
      </div>

      <div className="flex flex-col items-center gap-6 text-center">
        <div className="animate-pulse">
          <div
            className={cn(
              'flex h-28 w-28 items-center justify-center rounded-full bg-white/20 ring-4 ring-white/40 ring-offset-2',
              ringOffsetColor
            )}
          >
            <span className="text-6xl">{icon}</span>
          </div>
        </div>

        <h2 className="text-3xl font-black uppercase tracking-widest text-white">
          {responseState} Detected
        </h2>

        {responseMsg && (
          <div className="w-full rounded-2xl border border-white/20 bg-white/10 p-4">
            <p className="break-words text-xl font-black text-white uppercase leading-snug">
              {responseMsg}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
